export default "__VITE_ASSET__g_R9klkh__"